module.exports = __webpack_public_path__ + "img/save_icon.37e9bdf3.svg";